import BaseAddressProvider from './BaseAddressProvider'
import GoogleAddressProvider from './GoogleAddressProvider'
import ChronotruckAddressProvider from './ChronotruckAddressProvider'

export default class JoinAddressProvider extends BaseAddressProvider {
  constructor () {
    super()

    this.googleProvider = new GoogleAddressProvider([])
    this.chronotruckProvider = new ChronotruckAddressProvider()
  }

  /**
   * Returns a list of predictions according to a query
   * @method getPredictions
   * @param {string} query
   * @param {string} type - Either "pickup" or "delivery"
   * @returns {Promise<Array>} result
   */
  getPredictions (query, type) {
    return new Promise(resolve => {
      Promise.all([
        this.googleProvider.getPredictions(query),
        this.chronotruckProvider.getPredictions(query, type)
      ])
        .then(response => {
          const predictions = [
            ...response[0],
            ...response[1]
          ]

          /**
           * Re-order the predictions to ensure the Chronotruck addresses are on top.
           */
          resolve(predictions.sort(a => a.provider === 'ChronotruckAddressProvider' ? -1 : 1))
        })
    })
  }

  /**
   * Returns a detailed address item
   * @method getItem
   * @param {Object} prediction
   * @param {string} type - Either "pickup" or "delivery"
   * @param {Array} predictionsBag - A list of custom predictions to search for (only Ctk)
   * @returns {Promise<AddressComponent|Error>} result
   */
  getItem (prediction, type, predictionsBag = null) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        if (prediction.provider === 'ChronotruckAddressProvider') {
          const item = await this.chronotruckProvider.getItem(prediction.id, type, predictionsBag)
          resolve(item)
        } else {
          const item = await this.googleProvider.getItem(prediction.id)
          resolve(item)
        }
      } catch (e) {
        reject(e)
      }
    })
  }

  setCountries (countries) {
    if (this.googleProvider) this.googleProvider.setCountries(countries)
    if (this.chronotruckProvider) this.chronotruckProvider.setCountries(countries)
  }
}
